import React, { Component } from "react";
import { Link  } from 'react-router-dom';
import Pagination from "react-js-pagination";
import {GetData,PostData} from '../services/PostData';
import Loader from 'react-loader-spinner'
import AddTeam from './productionteams/AddTeam'
import EditTeam from './productionteams/EditTeam'
import ListTeam from './productionteams/ListTeam'
import ProjectList from './project/ProjectList';
import AddProject from './project/CreateProject';
import AddToProject from './AddToProject'
import TextComponent from './scriptWriterComponent/textComponent';
import { Dropdown } from 'react-bootstrap';
import { saveAs } from "file-saver";
import { Document, ImageRun, Packer, Paragraph } from "docx";
import { Button, Collapse, Modal, Alert, Row, Col, Container } from 'react-bootstrap';
import { toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import dateFormat from 'dateformat';


toast.configure()
class ScriptGenerate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orgdata: '',
            loading: false,
            isSelectedMessage:'',
            displaytype:'viewprojectlist',
            userid:'',
            projectlist:[],
            producescript:null,
            originalScript: '',
            word_length:'',
            setAddToProjectShow:false,
            isScriptEdit:false,
            editedboardid:'',
            scriptText: '',
            scriptDetail: {},
            isScriptSaved: false,
            projectlist: [],
            showAddToProject: false,
            selectedprojectInfo: {},
            Inloading: false,
            isScriptSavedInDb: false,
            categories: [
		        { title: 'Conferences & Events', id: 0 },
		        { title: 'Membership & Benefits', id: 1 },
		        { title: 'Advocacy & Public Affairs', id: 2 },
				{ title: 'Education', id: 3 },
				// { title: 'Something Else', id: 4 }
		    ],
			subcategories: [

				{ title: 'Promotional Video', id: 0, category: { title: 'Conferences & Events' } },
				{ title: 'Walk-in Video', id: 1, category: { title: 'Conferences & Events' } },
				{ title: 'Kickoff Video', id: 2, category: { title: 'Conferences & Events' } },
				{ title: 'Awards / Recognition Video', id: 3, category: { title: 'Conferences & Events' } },
				{ title: 'Wrap up / Highlight Video', id: 4, category: { title: 'Conferences & Events' } },
				// { title: 'Something Else', id: 5, category: { title: 'Conferences & Events' } },

				{ title: 'Industry Promotional Video', id: 6, category: { title: 'Membership & Benefits' } },
				{ title: 'Membership Benefits Video', id: 7, category: { title: 'Membership & Benefits' } },
				{ title: 'Membership Testimonial Video', id: 8, category: { title: 'Membership & Benefits' } },
				{ title: 'Year in Review Video', id: 9, category: { title: 'Membership & Benefits' } },
				{ title: 'Snapshot / Update Video', id: 11, category: { title: 'Membership & Benefits' } },
				// { title: 'Something Else', id: 10, category: { title: 'Membership & Benefits' } },

				{ title: 'Issue Explainer Video', id: 11, category: { title: 'Advocacy & Public Affairs' } },
				{ title: 'Capitol Day Promotional Video', id: 12, category: { title: 'Advocacy & Public Affairs' } },
				{ title: 'Press Conference', id: 13, category: { title: 'Advocacy & Public Affairs' } },
				// { title: 'Something Else', id: 14, category: { title: 'Advocacy & Public Affairs' } },

				{ title: 'In Person Meeting', id: 15, category: { title: 'Education' } },
				{ title: 'Webinar or Prerecorded', id: 16, category: { title: 'Education' } },
				{ title: 'One on One Training', id: 17, category: { title: 'Education' } },
				{ title: 'Promotional Video', id: 17, category: { title: 'Education' } },				
				// { title: 'Something Else', id: 18, category: { title: 'Education' } },	
			],
            selectedEmo: [],
            errors: {},
            date: '',
            selctedCategory: '',
            selctedSubCategory: '',
            location: '',
            videoTitle: '',
            keyPoint1: '',
            keyPoint2: '',
            keyPoint3: '',
            otherDetails: '',
            callToAction: '',
            isValidateForm: true,
            errormsg: '',
            error: {},
            openPopupEditor: false,
            updatedScriptForVoice: '',
            displaytype:'scriptList',
            activeTab: 'scriptList',
            scriptList: [],
            activePage: 1,
			itemPerPage:10,
            activeitemid:'',
            activeitemtype:'',
            activeitem:'',
            expandedIndex: null,
            limit: 200,
        };
        this.onChange = this.onChange.bind(this);
        //this.onScriptChange = this.onScriptChange.bind(this);
    }
    
    componentDidMount() {
        console.log('-------------------------------TESTING_ENV-----------------------------', process.env.REACT_APP_TESTING_ENV)
        console.log('-------------------------------TESTING_ENV working or not-----------------------------')
        this.setState({Inloading: true})
        this.fetchScriptList();
        
        const query = new URLSearchParams(this.props.location.search);
        const id = query.get('editscript');
        // console.log('editscript', id)

        if(id){
            this.setState({displaytype: 'createScript', activeTab: 'createScript'})
            GetData(`get/script/${id}`).then((result) => {
                console.log('result', result)
                if(result.success){
                    this.setState({
                        // userInput: result.script.script
                        producescript: result.script.script, isScriptSaved: true, isScriptSavedInDb: true, originalScript: result.script.script
                    });
                }
            });
        }

        Promise.all([this.getProjectList()])
        .then(([projectdata])  => {
            if(projectdata.statuscode===200)
            {
                this.setState({projectlist:projectdata.data});
            }
        });   
    }

    changeView(displaytype){
        this.setState({ displaytype: displaytype, activeTab: displaytype });
        if(displaytype === 'scriptList') {
            this.setState({Inloading: true})
            this.fetchScriptList();
        }
    }

    fetchScriptList = () => {
        GetData(`get/script/list/${this.props.match.params.orgid}`).then((result) => {
            console.log('result all script', result);
            this.setState({scriptList: result.scriptList, Inloading: false})
        });
    }

    getProjectList(){
        return GetData('orgprojectlist/'+this.props.match.params.orgid).then((result) => {
            return result;
        });
    }

    onChange(e){
        this.setState({[e.target.name]:e.target.value});
    }
    
    onScriptChange(text){
        // console.log('event.target.value=',event.target.value);
        // this.setState({ producescript: event.target.value });
        this.setState({ producescript: text });
    }
    
    validateForm = ()=>{
        this.setState({ isValidateForm: true })
        const isVideoTitle = this.state.videoTitle?.trim();
        const isKeyPoint = this.state.keyPoint1?.trim();
        let formIsValid = true;
        if(!this.state.selctedCategory && !isVideoTitle && !isKeyPoint && !this.state.selctedSubCategory ) {
            formIsValid = false;
            this.setState({errormsg: 'All fields are required', isValidateForm: false, error: {selectedCategory: 'All fields are required', selectedSubCat: 'All fields are required', videoTitle: 'All fields are required', keyPoint1: 'All fields are required'}})
        } else if(!this.state.selctedCategory){
            formIsValid = false;
            this.setState({errormsg: 'Please select video script category', isValidateForm: false, error: {selectedCategory: 'Please select category'}})
        } else if(!this.state.selctedSubCategory){
            formIsValid = false;
            this.setState({errormsg: 'Please select video script sub category', isValidateForm: false, error: {selectedSubCat: 'Please select sub category'}})
        } else if(!isVideoTitle){
            formIsValid = false;
            this.setState({errormsg: 'Please add script title', isValidateForm: false, error: {videoTitle: 'Please enter video title'}})
        } else if(!isKeyPoint){
            formIsValid = false;
            this.setState({errormsg: 'Please enter atleast one key point', isValidateForm: false, error: {keyPoint1: 'Please enter key point'}})
        }
        return formIsValid
    }

    generateScript(e){
        let userdata = localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData")).data;
    
        const moodCat = this.state.selectedEmo.map((emo)=>{
            return ` ${emo},`
        })
        let message='';
        if(this.validateForm()){
            this.setState({ Inloading: true });
            if(this.state.date && this.state.location) {
                message = `Please write a video script for the ${this.state.selctedCategory} - ${this.state.selctedSubCategory} for the "${this.state.videoTitle}". Here are the details:
                    Video script Details:
                    Video script Title: ${this.state.videoTitle}
                    video script category: ${this.state.selctedCategory}
                    video script subcategory: ${this.state.selctedSubCategory}
                    Date: ${this.state.date}
                    Location: ${this.state.location}
    
                    Specific Points to Emphasize:
                    ${this.state.keyPoint1? `1. ${this.state.keyPoint1}`: ''}
                    ${this.state.keyPoint2? `2. ${this.state.keyPoint2}`: ''}
                    ${this.state.keyPoint3? `3. ${this.state.keyPoint3}`: ''}
                    ${this.state.otherDetails? `4. ${this.state.otherDetails}`: ''}
    
                    ${ moodCat.length > 0 ?`Desired Tone: The script should be ${moodCat}.` : '' }
    
                    ${this.state.callToAction? `call to action: ${this.state.callToAction}`: ''}.
                `
            } else if(this.state.date) {
                message = `Please write a video script for the ${this.state.selctedCategory} - ${this.state.selctedSubCategory} for the "${this.state.videoTitle}". Here are the details:
                    Video script Details:
                    Video script Title: ${this.state.videoTitle}
                    video script category: ${this.state.selctedCategory}
                    video script subcategory: ${this.state.selctedSubCategory}
                    Date: ${this.state.date}
    
                    Specific Points to Emphasize:
                    ${this.state.keyPoint1? `1. ${this.state.keyPoint1}`: ''}
                    ${this.state.keyPoint2? `2. ${this.state.keyPoint2}`: ''}
                    ${this.state.keyPoint3? `3. ${this.state.keyPoint3}`: ''}
                    ${this.state.otherDetails? `4. ${this.state.otherDetails}`: ''}
    
                    ${ moodCat.length > 0 ?`Desired Tone: The script should be ${moodCat}.` : '' }
    
                    ${this.state.callToAction? `call to action: ${this.state.callToAction}`: ''}.
                `
            } else if(this.state.location) {
                message = `Please write a video script for the ${this.state.selctedCategory} - ${this.state.selctedSubCategory} for the "${this.state.videoTitle}". Here are the details:
                    Video script Details:
                    Video script Title: ${this.state.videoTitle}
                    video script category: ${this.state.selctedCategory}
                    video script subcategory: ${this.state.selctedSubCategory}
                    Location: ${this.state.location}
    
                    Specific Points to Emphasize:
                    ${this.state.keyPoint1? `1. ${this.state.keyPoint1}`: ''}
                    ${this.state.keyPoint2? `2. ${this.state.keyPoint2}`: ''}
                    ${this.state.keyPoint3? `3. ${this.state.keyPoint3}`: ''}
                    ${this.state.otherDetails? `4. ${this.state.otherDetails}`: ''}
    
                    ${ moodCat.length > 0 ?`Desired Tone: The script should be ${moodCat}.` : '' }
    
                    ${this.state.callToAction? `call to action: ${this.state.callToAction}`: ''}.
                `
            } else {
                message = `Please write a video script for the ${this.state.selctedCategory} - ${this.state.selctedSubCategory} for the "${this.state.videoTitle}". Here are the details:
                    Video script Details:
                    Video script Title: ${this.state.videoTitle}
                    video script category: ${this.state.selctedCategory}
                    video script subcategory: ${this.state.selctedSubCategory}
    
                    Specific Points to Emphasize:
                    ${this.state.keyPoint1? `1. ${this.state.keyPoint1}`: ''}
                    ${this.state.keyPoint2? `2. ${this.state.keyPoint2}`: ''}
                    ${this.state.keyPoint3? `3. ${this.state.keyPoint3}`: ''}
                    ${this.state.otherDetails? `4. ${this.state.otherDetails}`: ''}
    
                    ${ moodCat.length > 0 ?`Desired Tone: The script should be ${moodCat}.` : '' }
    
                    ${this.state.callToAction? `call to action: ${this.state.callToAction}.`: ''}
                `
            }
            
            // console.log('message = ', message)
    
            let data = {
                // text: this.state.scriptText,
                text: message,
                // userId: userdata.user.ID,
                // organizationId: this.props.match.params.orgid,
            }
            console.log('content data', data)
            PostData('create/content/',data).then((result) => {     
                console.log('result=',result);
                //let remainingcredits = result.data.credits-result.data.used_credit
                if(result.statusCode==200) {   
                //     let script = result.data;
                //     //script = script.replace('\n', '<br/>');
                    // this.setState({ producescript: result.script.script, loading: false, scriptDetail: result.script }); 
                    this.setState({originalScript: result.script, producescript: result.script, Inloading: false, isScriptSaved: false, isScriptSavedInDb: false }); 
                    toast.success('Script Created Successfully')
                }
            });
        }
    }

    handleSaveScript () {
        let userdata = localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData")).data;

        let data = {
            script: this.state.producescript,
            userId: userdata.user.ID,
            organizationId: this.props.match.params.orgid,
        }

        PostData('save/script',data).then((result) => {     
            console.log('result=',result);
            //let remainingcredits = result.data.credits-result.data.used_credit
            if(result.statusCode==200) {   
            //     let script = result.data;
            //     //script = script.replace('\n', '<br/>');
                this.setState({ scriptDetail: result.script, isScriptSaved: true, isScriptSavedInDb: true, updatedScriptForVoice: this.state.producescript });
                toast.success('Your script has been saved!')
            }
        });
    }
    
    handleUpdateScript () {
        let userdata = localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData")).data;
        this.setState({updatedScriptForVoice: this.state.producescript});
        let data = {
            script: this.state.producescript,
        }

        PostData(`update/script/${this.state.scriptDetail._id}`,data).then((result) => {
            console.log('result=',result);
            //let remainingcredits = result.data.credits-result.data.used_credit
            if(result.statusCode==200) {   
            //     let script = result.data;
            //     //script = script.replace('\n', '<br/>');
                this.setState({ scriptDetail: result.script });
                toast.success('Script has been updated successfully!')
            }
        });
    }

    handleConvertToVoice (){
        this.setState({openPopupEditor: true})
        // this.props.history.push(`/speech/generate/5d88bda562c33a2da8d38619?id=${this.state.scriptDetail._id}`);
    }
    handleConvertToVoiceFromList (scriptDetails, e){
        this.setState({updatedScriptForVoice: scriptDetails.script, scriptDetail: scriptDetails,  openPopupEditor: true})
    }

    setAddToProjectShow(e) {
        this.setState({ setAddToProjectShow: true });
    }
    handleCheck(e) {
        this.setState({ scheduletype: e.currentTarget.dataset.id, boarddisplaytype: '' });
        let script = this.state.producescript;
        const map1 = script ? script.split('\n').map((item, i) => new Paragraph(item)) : '';
        map1.unshift(new Paragraph({ text: 'Video Script', bold: true }));
        console.log('map1=', map1);
        const doc = new Document({
            sections: [
                {
                    children: map1
                }
            ]
        });

        const selectedproject = this.state.selectedproject + ' Script.docx'

        Packer.toBlob(doc).then(blob => {
            console.log(blob);
            saveAs(blob, selectedproject);
            console.log("Document created successfully");
        });


    }

    handleProjectSelect () {
        this.setState({showAddToProject: true})
    }
    handleProjectSelectScriptList (scriptInfo, e) {
        this.setState({producescript: scriptInfo.script, showAddToProject: true, scriptDetail: scriptInfo})
    }

    addScriptToProject(e){
        // let filedetails = this.state.filedetails;
        //console.log('filedetails==',filedetails);
        
        let userdata = localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData")).data;

        if(this.state.selectedproject=='') {
            this.setState({
                errormsg:'Please select Project'
            })
        } else {
            this.setState({
                errormsg:''
            })
            console.log('selectedproject', this.state.selectedproject)

            let data = {
				//'title': this.state.tcomment,
				'org_id': this.props.match.params.orgid,
				'projectid': this.state.selectedproject,
				//'scripttime': finaltime,
				'script': this.state.producescript,
				'project': this.state.selectedprojectInfo.project_name,
				'userid': userdata.user.ID,
				'scriptwritertitle': this.state.scriptText,
                'scriptId': this.state.scriptDetail._id
				// 'editedboardid':this.props.editedboardid
			}
			//console.log('data',data);
			this.savescriptdata(data);
        }

    }

    handleProjectChange(e){
        const selectedProjectInfo = this.state.projectlist.find(project => project._id === e.target.value);
        this.setState({ selectedprojectInfo: selectedProjectInfo, selectedproject: e.target.value });
    }

    handleAddToProjectClose(e) {
        this.setState({
            showAddToProject: false,
        });
    }

    savescriptdata(data) {
        this.setState({ Inloading: true });
        PostData('uploadscripttoprojectboard', data).then((result) => {
            if (result.statuscode === 200) {
                this.setState({ successmsg: "Script Added Succesfully" });
                setTimeout(() => {
                    this.setState({ successmsg: '', showAddToProject: false });
                    //this.props.loadProjectBoard(result.totaltime);
                }, 3000);
            }
            else if (result.statusCode === 401) {
                this.setState({ errormsg: result.Message });
                setTimeout(() => this.setState({ errormsg: '', showAddToProject: false }), 3000);
            }
            this.setState({ Inloading: false });
        });
    }

    handleCategoryChange(e) {
		this.setState({ selctedCategory: e.target.value });
	}	
	handleSubCategoryChange(e) {
		this.setState({ selctedSubCategory: e.target.value });
	}

    onEmoChange = text => {
        const selectedEmo = this.state.selectedEmo;

        // Find index
        const findIdx = selectedEmo.indexOf(text);

        // Index > -1 means that the item exists and that the checkbox is checked
        // and in that case we want to remove it from the array and uncheck it
        if (findIdx > -1) {
          selectedEmo.splice(findIdx, 1);
        } else {
          selectedEmo.push(text);
        }
        console.log('selectedEmo==',selectedEmo);
        this.setState({
          selectedEmo: selectedEmo
        });
    };

    handleChange = date => {
	    this.setState({
	      date: date
	    });
		let fromdate = date;
		var todate = new Date();  
		// To calculate the time difference of two dates
		var Difference_In_Time = fromdate.getTime() - todate.getTime();		
		// To calculate the no. of days between two dates
		var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        let numofdays = parseInt(Difference_In_Days);
		//console.log('due date  = ',fromdate,todate,Difference_In_Days,numofdays);
		if(numofdays<10)
		{
			let monthsList = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

			let date = fromdate.getDate();
			let month = monthsList[fromdate.getMonth()];
			let year = fromdate.getFullYear();

						
		}
		// else{
		// 	this.setState({
		// 		commingsoonmessage:''
		// 	});
		// }
	};

    handlePopupOpenForEdit () {
        this.setState({openPopupEditor: true});
    }

    handleUpdateScriptForVoice () {
        let userdata = localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData")).data;
        console.log('this.state.updatedScriptForVoice', this.state.updatedScriptForVoice)
        let data = {
            scriptForSpeech: this.state.updatedScriptForVoice
        }

        PostData(`update/script/${this.state.scriptDetail._id}`,data).then((result) => {
            console.log('script result=',result);
            //let remainingcredits = result.data.credits-result.data.used_credit
            if(result.statusCode==200) {   
            //     let script = result.data;
            //     //script = script.replace('\n', '<br/>');
                this.setState({ updatedScriptForVoice: result.scriptForSpeech });

                this.props.history.push(`/speech/generate/${this.props.match.params.orgid}?id=${this.state.scriptDetail._id}`);
                // toast.success('Script has been updated successfully!')
            }
        });
    }

    handlePageChange(pageNumber) {
        this.setState({ activePage: pageNumber });
    }

    toggleText = (index) => {
        this.setState({ expandedIndex: this.state.expandedIndex === index ? null : index });
    };


    render() {   
        let userdata = localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData")).data;

        let projects = this.state.projectlist.map((item, i) => {
            return <option key={i} className="folderlistitem" value={item._id}>
                {item.project_name}
            </option>;
        });

        const categories = this.state.categories.map(i => (
		    <option key={i.id} value={i.title}>
		      { i.title }		      
		    </option>
		));


        const subcategories = this.state.subcategories
            .filter(i => i.category.title === this.state.selctedCategory)
            .map(i => (
                <option key={i.id} value={i.title}>
                { i.title }		      
            </option>
        ));
        
        const ExampleCustomInput = ({ value, onClick }) => (
		    <button className="example-custom-input" onClick={onClick}>
		    	{<input type="text" value={value} /> /* <img src={require('../../assets/images/schedule-icon.png')}/> */}
		    </button>
		);

        const emoCheckboxes = [
            { id: 1, text: "Informed" },
            { id: 2, text: "Curious" },
            { id: 4, text: "Happy" },
            { id: 5, text: "Excited" },
            { id: 6, text: "Upset" },
            { id: 7, text: "Angry" },
            { id: 8, text: "Motivated" },
            { id: 9, text: "Sympathetic" },
            { id: 10, text: "Hopeful" },
            { id: 11, text: "Generous" },
            { id: 12, text: "Proud" },
            // { id: 13, text: "Something Else" },
        ];

        const { selectedEmo, activeTab } = this.state;
        
        let indexOfLastTodo = this.state.activePage * this.state.itemPerPage;
		let indexOfFirstTodo = indexOfLastTodo - this.state.itemPerPage;
        let renderedScripts = this.state.scriptList.slice(indexOfFirstTodo, indexOfLastTodo);
        // const filteredVoices = this.getFilteredVoices();

        
        let listItems = renderedScripts.map((item, index) => {
            // item.text = 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum'
            
            const isExpanded = this.state.expandedIndex === index;
            const displayedText = isExpanded ? item.script : (item.script ?item.script.substring(0, this.state.limit): item.script);

            return <tbody>
                <tr key={index}>                    
                    <td className="tbl_org_name speech-text" style={{width: '65%'}}>
                        {/* <p style={{marginBottom: '0px'}}>{item.text.substring(0, 100)}</p> */}
                        <div style={{marginBottom: '0px',}}>
                            {/* {item.text} */}
                            <div style={{whiteSpace: 'pre-wrap'}}>
                                {displayedText}
                            </div>
                            {!isExpanded && item.script && item.script.length > this.state.limit && `...`}
                            {item.script && item.script.length > this.state.limit && (
                                <span onClick={() => this.toggleText(index)} className='span-sm-sl'>
                                    {isExpanded ? 'Show Less' : 'Show More'}
                                </span>
                            )}
                        </div>
                    </td>
                    <td className="tbl_org_duedate">{dateFormat(item.createdAt, "mm/dd/yyyy")}</td>
                    <td className=" TblIconDel addPB-btn-tb">
                        {/* <button class="UpdateBtn btn btn-primary" onClick={()=>{this.handleProjectSelect(item)}} >Add to project</button> */}
                        <button className="btn btn-primary" style={{whiteSpace: 'nowrap'}} onClick={this.handleConvertToVoiceFromList.bind(this, item)}>Edit for Voice</button>
                        <button className="btn btn-primary" style={{whiteSpace: 'nowrap'}} onClick={this.handleProjectSelectScriptList.bind(this, item)}>Add to project</button>
                        {/* <i  className="fa fa-trash" aria-hidden="true"  onClick={(e) => { if (window.confirm('Are you sure you want to delete?')) this.handleDeleteSpeech(item) } } > <img src={require('../../assets/images/delete-icon.png')}/> </i> */}
                    </td>

                </tr>
            </tbody>
        });

        return (
            <div className='speech-main-div'>
                {
                    this.state.Inloading ?
                        <div className="loaderspinner">
                            <Loader
                                type="TailSpin"
                                color="#D10000"
                                height={100}
                                width={100}
                            />
                        </div>
                        : null
                }
                <div className='genSpeedHeading'>
                    <h3 className='speechPageHeading'>Script Writer</h3>
                </div>
                <div  className='speech-container ProAssetsList'>
                    <div className="row speechTabs">
                        <div className="col-12 col-sm-12 col-md-12 MobOrgProTab">
                            <ul className="top-links">
                                <li>
                                    {/* <a className={`forcusror speechtab-link ${activeTab === 'createScript' ? 'active' : ''}`} onClick={this.changeView.bind(this,'createScript')} > */}
                                    <a className={`forcusror`} onClick={this.changeView.bind(this,'createScript')} >
                                    Create Script</a>  
                                </li>
                                
                                <li> 
                                    {/* <a className={`forcusror speechtab-link ${activeTab === 'scriptList' ? 'active' : ''}`} onClick={this.changeView.bind(this,'scriptList')} > */}
                                    <a className={`forcusror`} onClick={this.changeView.bind(this,'scriptList')} >
                                    Script List</a>
                                </li>
                            </ul>
                            <hr/>
                        </div>
                    </div>

                    {   this.state.displaytype == 'createScript' &&
                        <>
                            <div style={{ marginBottom: '20px' }}>
                                {/* <label htmlFor="voiceDropdown">Select a Voice: </label> */}
                                <label>Purpose of the video</label>
                                <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
                                    {/* <select id="voiceDropdown" className="form-control" placeholder='Select voice'>
                                        <option value="" disabled>Select a purpose of the video</option>
                                        {this.state.videoPurpose.map(purpose => (
                                            <option key={purpose.id} value={purpose.id}>
                                                {purpose.type}
                                            </option>
                                        ))}
                                    </select> */}
                                    <div className="category ">
                                        {/* <label for="projectname">Category</label> */}
                                        <select name="taskstatus" className="form-control" value={this.state.category} onChange={this.handleCategoryChange.bind(this)} >
                                            <option value=" ">Video Category</option>
                                            {categories}
                                            
                                        </select>
                                        {this.state.errormsg && !this.state.selctedCategory && <div className="errorMsg">{this.state.error.selectedCategory}</div>}							
                                    </div>
                                    { (subcategories.length>0 &&
                                        <div className="category ">
                                            {/* <label for="projectname">Subcategory</label> */}
                                            <select name="taskstatus" className="form-control" value={this.state.subcategory} onChange={this.handleSubCategoryChange.bind(this)} >
                                                <option value=" ">Video Sub Category</option>
                                                {subcategories}										
                                            </select>
                                            {this.state.errormsg && !this.state.selctedSubCategory && <div className="errorMsg">{this.state.error.selectedSubCat}</div>}
                                        </div>
                                        )
                                    }
                                    <div className="row CreateProRadioBox">
                                        <div className="col-sm-12">
                                            <label for="projectname" class="ParentLab" >How should the viewer feel when watching the video?</label>
                                        </div>
                                        
                                        {emoCheckboxes.map(emo => (
                                            <div className="col-sm-2 hideinputbox">
                                                <label key={emo.id}>
                                                    <input
                                                        type="checkbox"
                                                        onChange={() => this.onEmoChange(emo.text)}
                                                        selected={selectedEmo.includes(emo.text)}
                                                    /> {emo.text}
                                                </label>
                                            </div>
                                        ))}	
                                                                
                                    </div>
                                    
                                    <div style={{display: 'flex', gap: '30px', width: '100%'}}>
                                        {/* <label>Date</label>
                                        <input type="text" placeholder=""></input> */}
                                        {/* <div className="CreateProRadioBox">
                                            <label for="projectname">Date</label>
                                            <div className="DueDate1"> 
                                                <DatePicker
                                                    dateFormat="MM-dd-yyyy"
                                                    className="form-control"
                                                    minDate={moment().toDate()}
                                                    selected={this.state.date}
                                                    onChange={this.handleChange} customInput={<ExampleCustomInput />}
                                                /> 
                                            </div>
                                        </div> */}
                                        { this.state.selctedCategory == `Conferences & Events` &&
                                            <div style={{width: '100%'}}>
                                                <label>Location</label>
                                                <input className="form-control" type="text" placeholder="Enter Location" value={this.state.location} onChange={this.onChange} name='location'></input>
                                            </div>
                                        }
                                    </div>
                                    <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
                                        <div>
                                            <input className="form-control" type="text" placeholder="Enter script title" value={this.state.videoTitle} onChange={this.onChange} name="videoTitle"></input>
                                            {this.state.errormsg && !this.state.videoTitle && <div className="errorMsg">{this.state.error.videoTitle}</div>}    
                                        </div>
                                        <div>
                                            <input className="form-control" type="text" placeholder="Enter Key points 1" value={this.state.keyPoint1} onChange={this.onChange} name="keyPoint1"></input>
                                            {this.state.errormsg && !this.state.keyPoint1 && <div className="errorMsg">{this.state.error.keyPoint1}</div>}
                                        </div>
                                        <div>
                                            <input className="form-control" type="text" placeholder="Enter Key points 2" value={this.state.keyPoint2} onChange={this.onChange} name="keyPoint2"></input>
                                        </div>
                                        
                                        <div>
                                            <input className="form-control" type="text" placeholder="Enter Key points 3" value={this.state.keyPoint3} onChange={this.onChange} name="keyPoint3"></input>
                                        </div>
                                        
                                        <div>
                                            <input className="form-control" type="text" placeholder="Enter other details" value={this.state.otherDetails} onChange={this.onChange} name="otherDetails"></input>
                                        </div>
                                        
                                        <div>
                                            <input className="form-control" type="text" placeholder="Enter call to action" value={this.state.callToAction} onChange={this.onChange} name="callToAction"></input>
                                        </div>
                                        
                                    </div>
                                </div>
                                {/* <div>
                                        <div>
                                            <Container>
                                                <Row lg={12} md={12} >
                                                    <Col lg={6} md={6}>
                                                        <input type="text" placeholder="Type Date" value={''} style={{width: '100%'}}></input>
                                                    </Col>
                                                    <Col lg={6} md={6}>
                                                        <input type="text" placeholder="Type Date" value={''} style={{width: '100%'}}></input>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </div>
                                    </div> */}
                                </div>
                                {/* <div>
                                    <input className="form-control" placeholder="Write a video script for the 50th Annual Conference in Las Vegas, NV..." type="text" value={this.state.scriptText} onChange={this.onChange} name="scriptText" />
                                </div> */}
                                <div className="col-6 col-sm-6" style={{paddingLeft: '0px'}}>
                                    <button type="button" onClick={this.generateScript.bind(this)} className="UpdateBtn btn btn-primary">Generate</button>
                                </div>
                                {/* <div className="col-6 col-sm-6 RightTopMenu">
                                    {this.state.producescript &&
                                        <Dropdown>
                                            <Dropdown.Toggle variant="success1" id="dropdown-basic">
                                                Action
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={this.handleCheck.bind(this)} data-id="Script">Download Script</Dropdown.Item>
                                                <Dropdown.Item onClick={this.setAddToProjectShow.bind(this)} data-id="addtoproject">Add to Project</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    }
                                </div> */}
                                <br/>
                                { this.state.producescript != null &&
                                    <div className="producescript">
                                        <TextComponent text={this.state.producescript} onScriptChange={this.onScriptChange.bind(this)} handleConvertToVoice={this.handleConvertToVoice.bind(this)} handleSaveScript={this.handleSaveScript.bind(this)} handleUpdateScript={this.handleUpdateScript.bind(this)} isScriptSaved={this.state.isScriptSaved} handleProjectSelect={this.handleProjectSelect.bind(this)} isScriptSavedInDb={this.state.isScriptSavedInDb}/>
                                    </div>
                                }
                                
                        </>
                    }
                    {   this.state.displaytype == 'scriptList' &&
                        <>
                            <div className="">
                                <div className="container-fluid ProjectList" ref="selfdiv">
                                    <div className="panel panel-primary">
                                        <div className="panel-body">
                                            <div className="row">                                                
                                                <table className="table table-striped ListTable">
                                                    <thead>
                                                        <tr>
                                                            {/* <th className="tbl_org_duedate"><b>Script</b></th>
                                                            <th className="tbl_org_action"><b>Audio</b></th> */}
                                                            <th className="tbl_org_name" style={{textAlign: 'center'}}><b>Script</b></th>
                                                            <th className="tbl_org_duedate"><b>Created Date</b></th>
                                                            <th className="" style={{textAlign: 'center'}}><b>Action</b></th>
                                                        </tr>
                                                    </thead>
                                                    {listItems}
                                                </table>
                                            </div>
                                            <div className="Mobrow">
                                                <Pagination
                                                    activePage={this.state.activePage}
                                                    itemsCountPerPage={10}
                                                    totalItemsCount={this.state.scriptList.length}
                                                    pageRangeDisplayed={5}
                                                    onChange={this.handlePageChange.bind(this)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>  
                            </div>
                        </>
                    }
                    
                    {
                        <>
                            <Modal show={this.state.showAddToProject}>
                                
                                <Modal.Header class="SelectProducerHead">
                                    <Modal.Title>Add To Project</Modal.Title>
                                </Modal.Header>
                                <Modal.Body class="SelectProducerModel">
                                    <div className="succes-msg">{this.state.successmsg}</div>
                                    <div className="error-msg">{this.state.errormsg}</div>
                                    <select name="projectname" className="form-control" value={this.state.selectedproject} onChange={this.handleProjectChange.bind(this)} >
                                        <option value=" ">Select Project</option>
                                        {projects}
                                        {/* <option value="Active">Active</option>
                                        <option value="On-hold">On-hold</option>
                                        <option value="Completed">Completed</option> */}
                                    </select>
                                </Modal.Body>
                                <Modal.Footer class="FullWidthModelFoot">
                                    <Button variant="secondary" onClick={this.handleAddToProjectClose.bind(this)}>
                                        X
                                    </Button>
                                    <Button variant="primary" onClick={this.addScriptToProject.bind(this)}>
                                        Add To Project
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </>
                    // (this.state.setAddToProjectShow &&
                    //     // <AddToProject orgid={this.props.match.params.orgid} userid={userdata.user.ID} prjid={this.state.prjid} project={this.state.selectedproject} producescript={this.state.producescript} handleAddToProjectShow={this.state.setAddToProjectShow} scriptwritertitle={this.state.eventname} isScriptEdit={this.state.isScriptEdit} editedboardid={this.state.editedboardid} />
                    // )
                    }
                    {
                        <>
                            <Modal size="xl" show={this.state.openPopupEditor}>
                                
                                <Modal.Header class="SelectProducerHead">
                                    <Modal.Title>Edit Script</Modal.Title>
                                </Modal.Header>
                                <Modal.Body class="SelectProducerModel">
                                    {/* <div className="succes-msg">{this.state.successmsg}</div>
                                    <div className="error-msg">{this.state.errormsg}</div> */}
                                    <label style={{fontWeight: 'bold'}}>Keep only the text you want converted to speech</label>
                                    <div>
                                        <textarea id="myText" value={this.state.updatedScriptForVoice} name="updatedScriptForVoice" style={{ "width": "100%" }} onChange={this.onChange}/>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer class="FullWidthModelFoot">
                                    <Button variant="secondary" onClick={()=>this.setState({openPopupEditor: false})}>
                                        X
                                    </Button>
                                    <Button variant="primary" onClick={this.handleUpdateScriptForVoice.bind(this)} >
                                        Send for voice over
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </>
                    // (this.state.setAddToProjectShow &&
                    //     // <AddToProject orgid={this.props.match.params.orgid} userid={userdata.user.ID} prjid={this.state.prjid} project={this.state.selectedproject} producescript={this.state.producescript} handleAddToProjectShow={this.state.setAddToProjectShow} scriptwritertitle={this.state.eventname} isScriptEdit={this.state.isScriptEdit} editedboardid={this.state.editedboardid} />
                    // )
                    }
                </div>
            </div>
        )
    }
}
export default ScriptGenerate;
